/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type PlanSettingsInfoType from '@jira/spa-apps__advanced-roadmaps-plan-settings/src/PlanSettingsAutoScheduler.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type { Props } from '@jira/portfolio-3__portfolio/src/app-simple-plans/view/settings/auto-scheduler/types.tsx';

/**
 * Plan Settings - auto-scheduler page
 */

export const LazyPlanSettingsAutoScheduler: LazyComponent<(props: Props) => React.JSX.Element> =
	// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazyForPaint<typeof PlanSettingsInfoType>(
		() =>
			markAsProductBundleReady(
				import(
					/* webpackChunkName: "async-plan-settings-auto-scheduler", jiraSpaEntry: "async-plan-settings-auto-scheduler" */ '@jira/spa-apps__advanced-roadmaps-plan-settings/src/PlanSettingsAutoScheduler.tsx'
				),
			),
		{ ssr: false },
	);

const AsyncPlanSettingsAutoScheduler = (): React.JSX.Element => (
	<LazyPage
		Page={LazyPlanSettingsAutoScheduler}
		pageId="plan-settings-auto-scheduler"
		shouldShowSpinner
	/>
);

export default AsyncPlanSettingsAutoScheduler;
